import { render, staticRenderFns } from "./HomeMancomuno.vue?vue&type=template&id=5de0fb40&"
import script from "./HomeMancomuno.vue?vue&type=script&lang=js&"
export * from "./HomeMancomuno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports